import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Personorg } from '../model/personorg';
import { Person } from '../model/person';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class MemberlistService {

  serviceUrl:string = environment.apiUrl+'/organization/';
  perssrvurl:string = environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/person/';
  constructor(private http:HttpClient) { }

  // getList(organizationId:String){
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json' 
  //     })
  //   }
  //   var getListUrl = this.serviceUrl + organizationId + '/members'
  //   var result = this.http.get<Personorg[]>(getListUrl, httpOptions);
  //   //console.log(result);
  //   return result;
  // }
  getPerson(personId:string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json' 
      })
    }
    return this.http.get<Person>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/person/'+personId,httpOptions);
  }
}
